import React from "react";
import PropTypes from "prop-types";
// Material imports
import makeStyles from "@mui/styles/makeStyles";
import LinearProgress from "@mui/material/LinearProgress";
import Fade from "@mui/material/Fade";
const useStyles = makeStyles(theme => ({
  hr: {
    height: 1,
    minHeight: 1,
    width: "100%",
    backgroundColor: theme.palette.secondary.light,
    marginTop: 16,
    marginBottom: 16
  },
  default: {
    backgroundColor: theme.background.default
  }
}));
const Separator = ({
  color,
  loading
}) => {
  const classes = useStyles();
  return /*#__PURE__*/React.createElement("div", {
    className: `${classes.hr} ${classes[color]}`
  }, /*#__PURE__*/React.createElement(Fade, {
    in: loading,
    style: {
      transitionDelay: loading ? "200ms" : "0ms"
    },
    unmountOnExit: true
  }, /*#__PURE__*/React.createElement(LinearProgress, {
    color: "secondary"
  })));
};
export default Separator;
Separator.propTypes = {
  loading: PropTypes.bool,
  color: PropTypes.string
};
Separator.defaultProps = {
  color: "secondary",
  loading: false
};